import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'
import { coursesApi } from '../../api/courses'
import Header from '../../components/layout/Header'
import Footer from '../../components/layout/Footer'
import Loading from '../../components/common/Loading'
import CourseCard from '../../components/course/CourseCard'
import SEO from '../../components/seo/SEO'
import './CourseList.css'

const CourseList = () => {
  const [searchParams] = useSearchParams()
  const [viewMode, setViewMode] = useState('grid')
  
  const search = searchParams.get('search') || ''
  const subjectId = searchParams.get('subject') || ''

  const { data, isLoading, error } = useQuery({
    queryKey: ['courses', search, subjectId],
    queryFn: () => coursesApi.getCourses({ search, subject_id: subjectId }),
  })

  if (isLoading) {
    return (
      <>
        <Header />
        <Loading fullScreen text="جاري التحميل..." />
        <Footer />
      </>
    )
  }

  if (error) {
    return (
      <>
        <Header />
        <div className="error-container">
          <p>حدث خطأ أثناء تحميل الدورات</p>
        </div>
        <Footer />
      </>
    )
  }

  const courses = data?.data?.courses || []
  
  const pageTitle = search 
    ? `نتائج البحث: ${search}` 
    : subjectId 
    ? 'الدورات حسب التخصص' 
    : 'جميع الدورات'

  return (
    <div className="course-list-page bg-gray-900 min-h-screen">
      <SEO
        title={pageTitle}
        description="تصفح جميع الدورات التعليمية المتاحة. دورات احترافية في مختلف المجالات والتخصصات."
        keywords="دورات, كورسات, تعليم أونلاين, دورات عربية, تعليم إلكتروني"
        url={search ? `/courses?search=${encodeURIComponent(search)}` : subjectId ? `/courses?subject=${subjectId}` : '/courses'}
      />
      <Header />
      <main className="course-list-main bg-gray-900">
        <div className="container mx-auto px-4">
          <div className="course-list-header">
            <h1 className="page-title text-white">الدورات التدريبية</h1>
            <div className="view-toggle">
              <button
                className={viewMode === 'grid' ? 'active' : ''}
                onClick={() => setViewMode('grid')}
              >
                Grid
              </button>
              <button
                className={viewMode === 'list' ? 'active' : ''}
                onClick={() => setViewMode('list')}
              >
                List
              </button>
            </div>
          </div>

          <div className={viewMode === 'grid' ? 'courses-grid' : 'courses-list'}>
            {courses.map((course) => (
              <CourseCard key={course.id} course={course} viewMode={viewMode} />
            ))}
          </div>

          {courses.length === 0 && (
            <div className="empty-state">
              <p>لا توجد دورات متاحة</p>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default CourseList

